import { GlobalError } from "components/global-error";

const ErrorHandler = defineComponent(() => {
  const error = useError();

  return () => {
    const err = error.value;
    if (!err) return <div>Error</div>;

    return (
      <div class="w-full h-full">
        {err.statusCode === 404 ? (
          <GlobalError
            title="Error 404"
            subtitle="Oops! We could not find the page you’re looking for!"
          />
        ) : (
          <GlobalError
            title="Ungoing Maintenance"
            subtitle="Our service is currently undergoing maintenance. We are working on getting it back online as soon as possible!"
          />
        )}
      </div>
    );
  };
});

export default ErrorHandler;
